<template>
    <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-6">
            <dashboard-item :order="lastVisitedOrder" icon="fa-search" title="Find An Order" seeAllLink="orders"></dashboard-item>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6">
            <dashboard-item :user="lastVisitedUser" icon="fa-users" title="Find A User" seeAllLink="users"></dashboard-item>
        </div>
    </div>
</template>
<script>
import DashboardItem from './DashboardItem'
export default {
    components: {
        DashboardItem
    },
    data() {
        return {
            lastVisitedOrder: JSON.parse(localStorage.getItem('verdaSupportLastOrder') || null),
            lastVisitedUser: JSON.parse(localStorage.getItem('verdaSupportLastUser') || null)
        }
    }
}
</script>
